export const BORDER_RADIUS_MULTIPLIER = 2.5;
